import React from 'react';
import {Spacing} from '@vkontakte/vkui';
import {Logotype} from "./Logotype";
import {Rating} from "./Rating";
import StartButton from "./StartButton";
import DailyBonus from "./DailyBonus";
import MissionsBanner from "./MissionsBanner";
import TournamentBanner from "./TournamentBanner";

function Home() {
    return (
        <div className="app-screen app-screen--safe-top">
            <div className="app-screen__content items-center">
                <Spacing size={12}/>
                <div className={"w-full"}><Logotype/></div>
                <Spacing size={32}/>
                <div className={"w-full"}><StartButton/></div>
                <Spacing size={12}/>
                <div className={"w-full"}><DailyBonus /></div>
                <Spacing size={12}/>
                <div className={"w-full"}><MissionsBanner/></div>
                <Spacing size={12}/>
                <div className={"w-full"}><TournamentBanner/></div>
                <Spacing size={12}/>
                <div className={"w-full"}><Rating/></div>
            </div>
        </div>
    );
}

export default Home;
